import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { appConstants } from '../../../_constants';
import { resumeListAction } from '../../../actions/SendResume';
import moment from 'moment-timezone';
import '../../../../public/index.css';

class ResumeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            request: true,
            disabled: false,
            addJobModal: false,
            addSubUserModal: false,
            deleteConfmModalAccount: false,
            resumeCount: 0,
            sizePerPage: 10,
            currentPage: 1,
            resumeList: []
        }
    }

    componentDidMount() {
        this.resumeList(10, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.resumeList && nextProps.resumeList.data && nextProps.resumeList.data.data.length > 0) {
            this.setState({
                resumeCount: nextProps.resumeList.data.count,
                resumeList: nextProps.resumeList.data.data
            })
        }
 
    }

    resumeList = (sizePerPage, page) => {
        let reqObj = {
            "limit": (sizePerPage ? sizePerPage : 10),
            "offset": (page ? page : 0),
            "order": "",
            "direction": "",
            "search": "",
        }
        this.props.resumeListAction(reqObj);
    }

    formatDate(iso_date) {
        if (typeof iso_date === 'undefined') {
            return moment().tz().format(appConstants.DATEFORMATNOTTIME);
        }
        return new Date(iso_date).toLocaleDateString("en-US");
    }

    onGetProjectSEDate(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            return (this.formatDate(row.updatedAt))
        } else {
            return <span>-</span>
        }
    }

    nameResumeList(cell, row, rowIndex) {
        if (row && row.userData) {
            return <div>{row.userData.firstName}</div>
        } else {
            return <span>-</span>
        }
    }

    dowloadResume(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + row.resumeImage;
            return <div>&nbsp;
                <a href={fileUrl} download={row.userEmail}><i className="fa fa-cloud-download"></i></a></div>
        } else {
            return <span>-</span>
        }
    }

    sizePerPageListChange(sizePerPage) {
        this.setState({
            sizePerPage: sizePerPage
        })
        this.resumeList(sizePerPage, this.state.page);
    }

    onPageChange(page, sizePerPage) {
        this.setState({
            currentPage: page,
            sizePerPage: sizePerPage
        })
        this.resumeList(sizePerPage, (page - 1));
    }

    render() {
        const { resumeList, sizePerPage, resumeCount } = this.state
        
        var options = {
            onPageChange: this.onPageChange.bind(this),
            page: this.state.currentPage,
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            sizePerPage: sizePerPage,
            paginationPosition: 'bottom',
            alwaysShowAllBtns: true,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
        };

        return (
            <div className="history-block">
                <h3 className="ac-head">History</h3>
                <div className="resume-history">
                    <div className="status-content">
                        <h4 className="history-status">Received Resume <span className="resume-counting">{resumeCount}</span> </h4>
                        <div className="status-content">
                            <BootstrapTable data={resumeList} options={options } remote={true} fetchInfo={ { dataTotalSize: this.state.resumeCount } } pagination>
                                <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                                <TableHeaderColumn width='292' tdAttr={{'data-attr':'Name' }} dataField='' dataFormat={this.nameResumeList.bind(this)}>Name</TableHeaderColumn>
                                <TableHeaderColumn width='116' tdAttr={{'data-attr':'Date' }} dataField='' dataFormat={this.onGetProjectSEDate.bind(this)}>Date</TableHeaderColumn>
                                <TableHeaderColumn width='110' tdAttr={{'data-attr':'Action' }} dataField='' dataFormat={this.dowloadResume.bind(this)}>Action</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        resumeList: state.SendResume.response,
    };
}

export default withRouter(connect(mapStateToProps, {
    resumeListAction,
})(ResumeList));


// WEBPACK FOOTER //
// ./src/components/JobProvider/Profile/ResumeList.js